export default "__VITE_ASSET__DAaj$iHj__"